import { render } from "./DropdownModal.vue?vue&type=template&id=c4b59dbc&scoped=true"
import script from "./DropdownModal.vue?vue&type=script&lang=js"
export * from "./DropdownModal.vue?vue&type=script&lang=js"

import "./DropdownModal.vue?vue&type=style&index=0&id=c4b59dbc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b59dbc"]])

export default __exports__